import type { IDataModifyAddressHappy } from "@/happyTheme/interfaces/dashboard/address/IDataModifyAddressHappy"
import { ref, type Ref } from "vue"

export const dataModifyAddressHappyEmpty = {
    address_id: 0,
    company: '',
    city: '',
    postalCode: '',
    address_1: '',
    address_2: '',
    code_postal_id: 0,
    zone_id: 0,
    default: false
}

export const dataModifyAddressHappy: Ref<IDataModifyAddressHappy> = ref(dataModifyAddressHappyEmpty)
